var _style, _polygon, _path, _path2, _path3, _path4, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZubieLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 867.3 332.49",
    style: {
      enableBackground: "new 0 0 867.3 332.49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#069;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.4,22.3 292.67,22.3 134.94,256.54 201.44,256.54 280.9,311.28 9.96,311.28 168.49,79.39 18.4,79.39  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.67,223.99l36.8-50.9l102.83,71.87c0,0,20.29,11.35,32.33,2.41s20.47-27.77,7.52-60.45l-103.13-71.37 l36.53-51.95L439.8,176.01l-35.69,50.87l-19.85-14.18c0,0,10.28,44.33-20.36,77.37s-66.68,23.13-86.2,10.51 C258.18,287.97,166.67,223.99,166.67,223.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.86,207.19c-3.28-65.55-42.61-91.36-76.62-96.28c-34.01-4.92-63.09,10.65-69.65,18.03V23.66h-62.56v110.23 l58.57,39.95l-43.24,62.13l-12.49-8.28c0,0-4.42,52.48-2.84,71c0,0,51.09,18.23,109.67,13.77 C558.3,307.98,602.14,272.75,598.86,207.19z M493.19,266.49c-23.4,2.17-41.01-12.18-41.01-12.18v-83.58c0,0,17.12-16.92,42.18-11.85 c25.06,5.07,38.88,20.75,40.09,52.36S516.6,264.32,493.19,266.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567.14,113.39v8.88c0,0,39.93,30.1,39.93,90.05s-39.93,84.07-39.93,84.07v16.06h66.85V113.39H567.14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M762.98,122.3c-56.63-29.71-118.15,5.94-122,15.73v146.82c0,0,27.27,27.6,80.75,27.6s86.34-24.8,86.34-24.8 v-39.5c0,0-38.1,25.17-75.51,25.17s-57.33-19.58-57.33-51.39h137.03C812.27,221.93,819.61,152.01,762.98,122.3z M676.29,192.56 c0,0,2.45-39.5,38.1-39.5c35.66,0,38.1,39.5,38.1,39.5H676.29z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 601.57,
    cy: 52.8,
    r: 34.82
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "846.85,289.38 842.21,296.87 837.64,289.38 834.52,289.38 834.52,307.1 837.64,307.1 837.64,296.08  842.24,303.13 846.85,296.08 846.85,307.1 849.96,307.1 849.96,289.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "823.99,289.38 819.08,289.38 819.08,292.49 823.99,292.49 823.99,307.1 827.1,307.1 827.1,292.49  832.01,292.49 832.01,289.38 827.1,289.38  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZubieLogoColor);
export default __webpack_public_path__ + "static/media/zubie_logo_color.0d02e577086d230a133288129bdbb453.svg";
export { ForwardRef as ReactComponent };